<template>
    <AxRoadPage
        :title="$t('ax_road.drivers')"
        :closable="$route.name === 'axRoadDriverDetails'"
    >
        <div v-if="driver" class="driver-details">
            <div class="driver-details__picture">
                <img
                    :src="
                        driver.picture ||
                            driver.external_picture ||
                            require('@/assets/icons/driver.png')
                    "
                    :alt="driver.name || $t('ax_road.drivers')"
                    class="driver-details__img"
                />
            </div>
            <div class="l-stack l-gap-3 l-padded-y">
                <DriverDetailsWidget
                    :driver="driver"
                    :show-avatar="false"
                    tachograph-route="axRoadDriverTachograph"
                    class="driver-details__section"
                />
                <TruckDetailsWidget
                    v-if="showTruck"
                    :tracker="truck"
                    trip-history-route="axRoadDriverTripHistory"
                    class="driver-details__section"
                />
                <WarningsWidget
                    v-if="driver.id"
                    :entity-id="driver.id"
                    entity-type="driver"
                />
            </div>
        </div>
    </AxRoadPage>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import AxRoadPage from '@/components/ax-road/AxRoadPage'
import DriverDetailsWidget from '@/components/ax-road/DriverDetailsWidget'
import TruckDetailsWidget from '@/components/ax-road/TruckDetailsWidget'
import WarningsWidget from '@/components/ax-road/WarningsWidget'
import { throttle } from 'lodash'

export default {
    name: 'DriverDetailsView',
    components: {
        AxRoadPage,
        DriverDetailsWidget,
        TruckDetailsWidget,
        WarningsWidget,
    },
    data() {
        return {
            driver: {},
            truck: {},
        }
    },
    computed: {
        ...mapGetters('tracker', ['assetsByAssetId', 'driversById']),
        showTruck() {
            const cardIsPresent =
                this.truck?.asset_details?.sensor_data?.driver_1_card_presence
                    ?.value === 1
            const driverIdMatches =
                this.truck?.asset_details?.sensor_data?.driver_id?.value ==
                this.driver?.driver_id
            return cardIsPresent && driverIdMatches
        },
    },
    watch: {
        '$route.params.id': {
            immediate: true,
            handler(driverId) {
                this.setDriver(driverId)
            },
        },
        truck: {
            immediate: true,
            deep: true,
            handler(newTruck, oldTruck) {
                if (newTruck?.id !== oldTruck?.id) {
                    this.fetchDriverTimes(this.driver.driver_id)
                } else {
                    this.fetchDriverTimesThrottled(this.driver.driver_id)
                }
            },
        },
    },
    mounted() {
        this.setDriver(this.$route.params.id)
    },
    beforeRouteLeave(to, from, next) {
        this.setActiveTrackerOnMap(null)
        next()
    },
    methods: {
        ...mapMutations('tracker', ['setActiveTrackerOnMap']),
        ...mapMutations('axroad', ['setCurrentDriverId']),
        ...mapActions('axroad', ['fetchDriverTimes']),
        setDriver(driverId) {
            this.setActiveTrackerOnMap(null)

            this.driver = this.driversById[driverId] || {}
            this.setCurrentDriverId(driverId)
            this.truck = this.assetsByAssetId[this.driver.last_asset?.id] || {}
            if (this.showTruck) {
                this.setActiveTrackerOnMap(this.truck)
            }
        },
        fetchDriverTimesThrottled: throttle(function(driverId) {
            this.fetchDriverTimes(driverId)
        }, 30000),
    },
}
</script>

<style lang="scss" scoped>
.driver-details {
    &__img {
        width: 100%;
    }

    &__icon {
        filter: invert(1) brightness(0);
    }

    &__section {
        padding: 0 24px 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        border-bottom: $style-border;

        &--nopadding {
            padding: 0;
        }
    }
}
</style>
